import { Camera, ImagePlus, X } from "lucide-react";

interface ImageUploadZoneProps {
  imagePreview: string | null;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  cameraInputRef: React.RefObject<HTMLInputElement | null>;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: () => void;
}

export default function ImageUploadZone({
  imagePreview,
  fileInputRef,
  cameraInputRef,
  onFileChange,
  onRemove,
}: ImageUploadZoneProps) {
  return (
    <div className="relative">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={onFileChange}
        className="hidden"
      />
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={onFileChange}
        className="hidden"
      />
      {imagePreview ? (
        <div className="relative rounded-2xl overflow-hidden bg-neutral-100 aspect-[3/1]">
          <img
            src={imagePreview}
            alt="Preview"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
          <div className="absolute bottom-3 inset-x-3 flex gap-2">
            <button
              type="button"
              onClick={() => cameraInputRef.current?.click()}
              className="flex-1 h-10 rounded-xl bg-white/90 backdrop-blur-sm text-sm font-medium text-neutral-800 flex items-center justify-center gap-1.5 hover:bg-white transition active:scale-[0.98]"
            >
              <Camera className="size-4" />
              Slikaj
            </button>
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              className="flex-1 h-10 rounded-xl bg-white/90 backdrop-blur-sm text-sm font-medium text-neutral-800 flex items-center justify-center gap-1.5 hover:bg-white transition active:scale-[0.98]"
            >
              <ImagePlus className="size-4" />
              Galerija
            </button>
            <button
              type="button"
              onClick={onRemove}
              className="size-10 rounded-xl bg-white/90 backdrop-blur-sm flex items-center justify-center hover:bg-red-50 hover:text-red-500 transition active:scale-[0.98]"
            >
              <X className="size-4" />
            </button>
          </div>
        </div>
      ) : (
        <div className="flex gap-3 aspect-[3/1]">
          <button
            type="button"
            onClick={() => cameraInputRef.current?.click()}
            className="flex-1 rounded-2xl border-2 border-dashed border-neutral-200 hover:border-neutral-400 bg-neutral-50 hover:bg-neutral-100 transition-all flex flex-col items-center justify-center gap-2 active:scale-[0.98] cursor-pointer group"
          >
            <div className="size-12 rounded-xl bg-white border border-neutral-200 group-hover:border-neutral-300 flex items-center justify-center transition-colors shadow-sm">
              <Camera className="size-5 text-neutral-400 group-hover:text-neutral-600 transition-colors" />
            </div>
            <span className="text-xs font-medium text-neutral-400 group-hover:text-neutral-600 transition-colors">
              Slikaj
            </span>
          </button>
          <button
            type="button"
            onClick={() => fileInputRef.current?.click()}
            className="flex-1 rounded-2xl border-2 border-dashed border-neutral-200 hover:border-neutral-400 bg-neutral-50 hover:bg-neutral-100 transition-all flex flex-col items-center justify-center gap-2 active:scale-[0.98] cursor-pointer group"
          >
            <div className="size-12 rounded-xl bg-white border border-neutral-200 group-hover:border-neutral-300 flex items-center justify-center transition-colors shadow-sm">
              <ImagePlus className="size-5 text-neutral-400 group-hover:text-neutral-600 transition-colors" />
            </div>
            <span className="text-xs font-medium text-neutral-400 group-hover:text-neutral-600 transition-colors">
              Galerija
            </span>
          </button>
        </div>
      )}
    </div>
  );
}
